import { createAsyncActionType } from './index';

export const POST_CREATE_ACCOUNTS_CSV = createAsyncActionType(
  'people',
  'POST_CREATE_ACCOUNTS_CSV'
);

export const CREATE_ACCOUNT = createAsyncActionType('people', 'CREATE_ACCOUNT');

export const GET_ALL_ACCOUNTS = createAsyncActionType(
  'people',
  'GET_ALL_ACCOUNTS'
);

export const UPDATE_ACCOUNT = createAsyncActionType('people', 'UPDATE_ACCOUNT');

export const FETCH_SAMPLE_CSV = createAsyncActionType(
  'people',
  'FETCH_SAMPLE_CSV'
);

export const DELETE_ACCOUNT = createAsyncActionType('people', 'DELETE_ACCOUNT');

export const DOWNLOAD_CSV = createAsyncActionType('people', 'DOWNLOAD_CSV');

export const FETCH_CSV_HISTORY = createAsyncActionType(
  'people',
  'FETCH_CSV_HISTORY'
);

export const GET_ROW_ID_STATUS = createAsyncActionType(
  'people',
  'GET_ROW_ID_STATUS'
);

export const STOP_FILE_HISTORY_POLLING = createAsyncActionType(
  'people',
  'STOP_FILE_HISTORY_POLLING'
);

export const CHANGE_USER_ROLE = createAsyncActionType('people', 'CHANGE_ROLE');

export const RESEND_EMAIL = createAsyncActionType('people', 'RESEND_EMAIL');

export const GET_COMPANIES_LIST = createAsyncActionType(
  'people',
  'GET_COMPANIES_LIST'
);

export const DOWNLOAD_USERS_LIST = createAsyncActionType(
  'people',
  'DOWNLOAD_USERS_LIST'
);
